var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16016 14.0024C2.16016 9.58417 5.74188 6.00244 10.1602 6.00244H23.4935C27.9118 6.00244 31.4935 9.58416 31.4935 14.0024V19.3358C31.4935 23.754 27.9118 27.3358 23.4935 27.3358H2.16016V14.0024Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16016 14.0024C2.16016 9.58417 5.74188 6.00244 10.1602 6.00244H23.4935C27.9118 6.00244 31.4935 9.58416 31.4935 14.0024V19.3358C31.4935 23.754 27.9118 27.3358 23.4935 27.3358H2.16016V14.0024Z",
    fill: "url(#paint0_linear_1455_6829)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7399 16.2602C24.4539 14.429 23.609 12.9176 22.2061 11.7297C20.7313 10.4562 18.9344 9.81885 16.8156 9.81885C14.6961 9.81885 12.8993 10.4489 11.4253 11.7077C10.0217 12.9113 9.18435 14.429 8.91266 16.2602C8.85508 16.5612 8.82617 16.8475 8.82617 17.1201C8.82617 18.3227 9.21975 19.3744 10.0079 20.2768C10.7949 21.1787 11.9047 21.8381 13.337 22.2521V22.5756C13.337 22.9759 13.4727 23.3127 13.7447 23.5843C14.0164 23.8566 14.353 24.0072 14.754 24.0356C15.1692 24.0646 15.4766 23.9927 15.6772 23.821C15.9919 24.0495 16.3429 24.164 16.7297 24.164C17.0876 24.164 17.4173 24.0571 17.7174 23.8424C17.9182 23.9993 18.2113 24.0646 18.5983 24.0356C18.9988 23.9927 19.3357 23.8387 19.6075 23.5741C19.8794 23.3079 20.0153 22.976 20.0153 22.5756V22.3395C21.5613 21.9381 22.757 21.2655 23.6022 20.3195C24.4182 19.4181 24.8262 18.3518 24.8262 17.1201C24.8262 16.8475 24.7973 16.5612 24.7399 16.2602ZM14.9687 18.3331C14.539 18.8277 14.0232 19.0739 13.4224 19.0739C12.8212 19.0739 12.3057 18.8278 11.8762 18.3331C11.4467 17.8393 11.2317 17.241 11.2317 16.5395C11.2317 15.8384 11.4467 15.2404 11.8762 14.7475C12.3057 14.2537 12.8212 14.0067 13.4224 14.0067C14.0232 14.0067 14.539 14.2537 14.9687 14.7475C15.3984 15.2404 15.6136 15.8384 15.6136 16.5395C15.6136 17.241 15.3984 17.8392 14.9687 18.3331ZM16.8368 21.1787C16.4788 21.1787 16.2139 21.0865 16.0425 20.9031C15.9421 20.7886 15.8924 20.6477 15.8924 20.4773C15.8924 20.209 15.9959 19.9401 16.2036 19.6704C16.411 19.4021 16.6147 19.2675 16.8156 19.2675C17.0161 19.2675 17.2051 19.4159 17.3844 19.7145C17.5633 20.0115 17.6536 20.294 17.6536 20.5637C17.6536 20.9744 17.381 21.1787 16.8368 21.1787ZM21.5725 18.3331C21.15 18.8277 20.6312 19.0739 20.0152 19.0739C19.4142 19.0739 18.9025 18.8278 18.4802 18.3331C18.0573 17.8393 17.8461 17.241 17.8461 16.5395C17.8461 15.8384 18.0573 15.2404 18.4802 14.7475C18.9025 14.2537 19.4142 14.0067 20.0152 14.0067C20.6312 14.0067 21.1502 14.2537 21.5725 14.7475C21.9945 15.2404 22.2061 15.8384 22.2061 16.5395C22.2062 17.241 21.9945 17.8392 21.5725 18.3331Z",
    fill: "url(#paint1_linear_1455_6829)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_6829",
    x1: 5.22435,
    y1: 6.00244,
    x2: 17.6959,
    y2: 34.9456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D692FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_6829",
    x1: 16.8262,
    y1: 9.81885,
    x2: 16.8262,
    y2: 24.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.37
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon3);
export default __webpack_public_path__ + "static/media/message_card_icon3.8bcbd1a3a60a4a05150b89d90eafa747.svg";
export { ForwardRef as ReactComponent };